import AddDegreeModal from "./AddDegreeModal/AddDegreeModal";
import AdminTable from "../AdminTable/AdminTable";
import React, { useContext, useEffect, useState } from "react";
import "../../../styles/Layout/Admin_Styles/_Degree.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { AuthContext } from "../../../context/AuthContext";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AlertConfirm from "../../../shared/AlertBox/AlertConfirm/AlertConfirm";

const TableHeadData = [
  // { id: "qualification_type", label: "Qualification Type" },
  { id: "name", label: "Degree Name" },
  // { id: "action", label: "Action", action: true, alignItem: 'center' }
  // { id: "subject_name", label: "Subject Name" },
  // { id: "date", label: "Date" },
  // { id: "action", label: "Action" },
];

const actions = [
  {
    title: 'Delete',
    icon: <DeleteIcon className="text-danger" />,
    type: 'delete',
    className: 'text-danger'
  }
]

function Degree() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [data, setData] = useState([]);
  const { setIsLoading, setAlertState, setIsTableLoading, setToastState } = useContext(AuthContext);
  const [actionOpen, setActionOpen] = React.useState({})
  const [qualifications, setQualifications] = useState([])
  const [paginationData, setPaginationData] = useState({
    currentPage: 0,
    totalRecord: 0,
    rowsPerPage: 10,
  });

  const [selectedData, setSelectedData] = useState({
    qual_id:''
  })

  useEffect(() => {
    setIsLoading(true)
    setIsTableLoading(true)
    getQualList()
  }, []);

  const actionHandleClose = (type) => {
    if (type) {
      setIsLoading(true);
      setIsTableLoading(true);
      authHttp.post(apisPath?.admin?.deleteDegree, { degree_id: actionOpen?.id }).then((res) => {
        setToastState((prev) => ({ ...prev, open: true, msg: res?.data?.msg }));
        getData(paginationData?.currentPage + 1, selectedData?.qual_id)
      }).catch((err) => {
        setIsLoading(false);
        setIsTableLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      })
    }
    setActionOpen((prev) => (
      {
        ...prev,
        [actionOpen?.selectedModal]: false,
        selectedModal: '',
        id: '',
        name: ''
      }
    ))
  }

  const handleActions = (type, id, name) => {
    setActionOpen((prev) => (
      {
        ...prev,
        [type]: true,
        selectedModal: type,
        id: id,
        name: name
      }
    ))
  }

  const getData = (page, qualification_id) => {
    authHttp
      .post(
        apisPath?.admin?.getDegree + `?page=${page}`, { qualification_id: qualification_id }
      )
      .then((res) => {
        setData(res?.data?.data);
        setPaginationData((prev) => ({
          ...prev,
          totalRecord: res?.data?.totalCount,
          rowsPerPage: res?.data?.resultperpage,
        }));
        setIsLoading(false);
        setIsTableLoading(false);
        // console.log("search by data:" + res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const pageChangeHandler = (page) => {
    setIsTableLoading(true)
    getData(page + 1, selectedData?.qual_id);
    setPaginationData((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const getQualList = () => {
    authHttp
      .get(
        apisPath?.admin?.getQualification
      )
      .then((res) => {
        setSelectedData((prev) => (
          {
            ...prev,
            qual_id: res?.data?.data[0]?.id
          }
        ))
        setQualifications(res?.data?.data);
        getData(1, res?.data?.data[0]?.id)
        // console.log("search by data:" + res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  }

  const handleAddDegree = () => {
    handleClose()
    getData(paginationData?.currentPage + 1, selectedData?.qual_id)
  }

  return (
    <div className="degree">
      <div className="degree--header">
        <h2>Degree</h2>
      </div>
      <div className="degree--card">

        <div className="degree--modal_wrapper">
          <Grid container marginBottom={"30px"}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="degree-modal--select">
                <FormControl fullWidth>
                  <InputLabel id="qualification_type-label">
                    Select Qualification Type
                  </InputLabel>
                  <Select
                    fullWidth
                    autoComplete="off"
                    labelId="qualification_type-label"
                    id="qualification_type"
                    label="Qualification Type"
                    name="qualification_type"
                    value={selectedData?.qual_id}
                    onChange={(e) => {
                      setIsLoading(true)
                      setIsTableLoading(true)
                      getData(1, e?.target?.value)
                      setSelectedData((prev) => (
                        {
                          ...prev,
                          qual_id: e?.target?.value
                        }
                      ))
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: "250px",
                          overflowY: "auto",
                        },
                      },
                    }}
                  >
                    {qualifications?.map((qual) => (
                      <MenuItem key={qual?.id} value={qual?.id}>{qual?.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="degree-modal--button">
                <Button
                  variant="contained"
                  onClick={() => {
                    setOpen(true)
                  }}
                  className="degree-modal--button"
                  startIcon={<AddCircleOutlineIcon />}
                >
                  Add Degree
                </Button>
              </div>
            </Grid>
          </Grid>

        </div>

        <div className="degree--table">
          <AdminTable
            tableHead={TableHeadData}
            pageChangeHandler={pageChangeHandler}
            data={data}
            paginationData={paginationData}
            // actions={actions}
            // handleActions={handleActions}
          />
        </div>
        <AddDegreeModal open={open} handleClose={handleClose} qualification_id={selectedData?.qual_id} handleAddDegree={handleAddDegree} />
        {actionOpen[actionOpen?.selectedModal] &&
          <AlertConfirm
            open={actionOpen[actionOpen?.selectedModal]}
            actionData={actionOpen}
            handleClose={actionHandleClose}
          />
        }
      </div>
    </div>
  );
}

export default Degree;
